import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SHARED_ENVIRONMENT } from '@k12/environment';
import { ProgramPartner, ProgramPartnerType } from '@k12/models';

@Injectable({
  providedIn: 'root'
})
export class ProgramPartnerService {
  private http: HttpClient = inject(HttpClient);
  private sharedEnvironment = inject(SHARED_ENVIRONMENT);
  private apiUrl = this.sharedEnvironment.adminApiUrl;

  // A note on program partner types: it was decided that they should be called User Types in the UI
  // I don't think it makes sense to rename everything in the codebase, so the service and method names remain as program partner types
  // For searchability: userType UserType user-type
  //                    programPartnerType ProgramPartnerType program-partner-type

  public getProgramPartnerTypes(): Observable<HttpResponse<ProgramPartnerType[]>> {
    return this.http.get<ProgramPartnerType[]>(`${this.apiUrl}/programpartnertypes`, { observe: 'response' });
  }

  public getProgramPartner(id: string): Observable<HttpResponse<ProgramPartner>> {
    return this.http.get<ProgramPartner>(`${this.apiUrl}/partners/programpartners/${id}`, { observe: 'response' });
  }

  public getAllProgramPartners(): Observable<HttpResponse<ProgramPartner[]>> {
    return this.http.get<ProgramPartner[]>(`${this.apiUrl}/partners/programpartners`, { observe: 'response' });
  }
}
